import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../shared/constants';
import { getHistoricalRecordById } from '../../../shared/services';
const useGetHistoricalRecordById = (id) => {
    return useQuery({
        queryKey: [QueryKeys.GetHistoricalRecordById, id],
        queryFn: async () => await getHistoricalRecordById(id).then((data) => data.data),
    });
};
export default useGetHistoricalRecordById;
